import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';
import AOS from 'aos';

/**
 * Filter-Container: filtert die enthaltenen Elemente nach Begriffen (Auswahlfeld oder Checkboxen)
 * und per Volltextsuche. Begriffe sind ODER-verknüpft, Begriffe und Suche UND-verknüpft.
 */
class FilterContainer {
  constructor(container) {
    this.container = container;
    this.select = container.querySelector('.hrg-filter-select');
    this.checkboxes = container.querySelectorAll('.hrg-filter-term');
    this.searchInput = container.querySelector('.filter-search');
    this.noResults = container.querySelector('.hrg-filter-no-results');
    this.items = Array.from(container.querySelectorAll('.hrg-filter-item')).map(element => ({
      element,
      terms: (element.dataset.filterTerms || '').split(',').map(t => t.trim().toLowerCase()).filter(Boolean),
      text: element.textContent.toLowerCase(),
    }));

    if (this.select) {
      new Choices(this.select, {
        removeItemButton: true,
        itemSelectText: '',
        placeholderValue: this.select.dataset.placeholder || '',
        noResultsText: 'Keine Treffer',
        noChoicesText: 'Keine weiteren Begriffe',
        shouldSort: false,
      });
      this.select.addEventListener('change', () => this.filter());
      document.fonts.ready.then(() => this.setPlaceholderWidth());
    }
    this.checkboxes.forEach(checkbox => checkbox.addEventListener('change', () => this.filter()));
    this.searchInput?.addEventListener('input', () => this.filter());
  }

  /**
   * Choices bemisst das Eingabefeld in ch-Einheiten, was bei schmalen Schriften eine Lücke
   * vor dem Pfeil erzeugt. Daher wird die tatsächliche Breite des Platzhalters gemessen.
   */
  setPlaceholderWidth() {
    const input = this.container.querySelector('.choices__input--cloned');
    if (!input || !input.placeholder) {
      return;
    }
    const context = document.createElement('canvas').getContext('2d');
    context.font = getComputedStyle(input).font;
    const width = Math.ceil(context.measureText(input.placeholder).width) + 4;
    input.style.setProperty('--placeholder-width', `${width}px`);
  }

  getSelectedTerms() {
    if (this.select) {
      return Array.from(this.select.selectedOptions).map(option => option.value);
    }
    return Array.from(this.checkboxes).filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
  }

  filter() {
    const selectedTerms = this.getSelectedTerms();
    const searchWords = (this.searchInput?.value || '').toLowerCase().split(/\s+/).filter(Boolean);
    let visibleCount = 0;

    this.items.forEach(item => {
      const termMatch = selectedTerms.length === 0 || item.terms.some(term => selectedTerms.includes(term));
      const searchMatch = searchWords.every(word => item.text.includes(word) || item.terms.some(term => term.includes(word)));
      const isVisible = termMatch && searchMatch;

      item.element.hidden = !isVisible;
      if (isVisible) {
        visibleCount++;
      }
    });

    if (this.noResults) {
      this.noResults.hidden = visibleCount > 0;
    }

    AOS.refresh();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hrg-filter-container').forEach(container => new FilterContainer(container));
});
